import React, { useEffect, useState } from "react";
import { Button, Col, Container, Form, Row } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import moment from "moment";
import FadeLoader from "react-spinners/FadeLoader";
import avatar from "../../../../Assets/images/avatar.png";
import { toast } from "react-toastify";
import AddCharacterModal from "../../../../components/Modals/AddCharacterModal";
import inputFields from "../../CharacterSetting/InputFields";
import Validation from "../../CharacterSetting/Valiadtion";
import TableLayout from "../../../../components/TableLayout";
import { useNavigate } from "react-router-dom";
import {
  characterList,
  deleteCharacterList,
  editCharacterStatus,
  updateBelovedRealisticStatus,
} from "../../../../store/character/actions";
const PublicCharacter = () => {
  const dispatch = useDispatch();
  const [currentPage, setCurrentPage] = useState(1);
  const navigate = useNavigate();
  const [pageSize, setPageSize] = useState(10);
  const [status, setStatus] = useState();
  const [tokenData, setTokenData] = useState();
  const capitalize = (str) =>
    str ? str.charAt(0).toUpperCase() + str.slice(1) : "";
  const [appearanceData, setAppearanceData] = useState();
  const [selectedFilters, setSelectedFilters] = useState({});
  const [addModalShow, setAddModalShow] = useState();
  const [type, setType] = useState("Ethnicity");
  const [style, setStyle] = useState("Realistic");
  const [search, setSearch] = useState();
  const { CHARACTERLIST, loading, totalCount } = useSelector(
    (state) => state.CharacterList,
  );
  console.log(CHARACTERLIST, totalCount, "CHARACTERLIST");

  const [formData, setFormData] = useState({
    type: "",
    name: "",
    image: "",
  });
  const [filter, setFilter] = useState({
    type: "public",
    pageNo: currentPage,
    limit: pageSize,
    status: status,
    belovedRealistic: true,
    style: style,
  });
  const fetchData = async () => {
    try {
      const callback = (err, res) => {
        if (err) {
          toast.error(err);
        } else {
          console.log(res);
          setTokenData(res);
          toast.success(res.message);
        }
      };
      dispatch(characterList({ data: filter, callback }));
    } catch (error) {
      console.error(error, "<===err");
    }
  };
  const fetchApearanceData = async () => {
    try {
      const callback = (err, res) => {
        if (err) {
          toast.err(err);
        } else {
          console.log(res, "resposne dta");
          setAppearanceData(res);
        }
      };
      // dispatch(getAppearnace({ callback }));
    } catch (error) {
      console.log(error, "error");
    }
  };
  useEffect(() => {
    fetchApearanceData();
  }, []);
  useEffect(() => {
    const timer = setTimeout(() => fetchData(), 500);
    return () => clearTimeout(timer);
  }, [filter]);

  const handleSelectChange = (fieldName, value) => {
    setSelectedFilters((prev) => ({
      ...prev,
      [fieldName]: value,
    }));
  };
  const handleFilter = () => {
    const filterArray = Object.keys(selectedFilters).map((key) => ({
      fieldName: key,
      fieldValue: selectedFilters[key],
    }));
    setFilter((prev) => ({
      ...prev,
      filter: filterArray,
      pageNo: 1,
    }));
  };
  const clearFilter = () => {
    setSelectedFilters({});
    setFilter({ type: "personal", pageNo: 1, limit: pageSize });
  };
  const onClickFilter = () => {
    setFilter((prev) => ({
      ...prev,
      pageNo: 1,
      type,
    }));
  };
  const handleEdit = (info) => {
    setFormData((prev) => {
      return {
        ...prev,
        _id: info._id,
        type: info.type,
        name: info.name,
        image: info.image,
      };
    });
    setAddModalShow(true);
  };

  const handleSubmit_ = (info) => {
    try {
      const callback = (err, res) => {
        if (err) {
          toast.error(err);
        } else {
          console.log(res);
          setAddModalShow(false);
          fetchData();
          toast.success(res.message);
        }
      };
      if (info.hasOwnProperty("_id")) {
        // dispatch(
        //   editCharacter({
        //     data: info,
        //     callback,
        //   })
        // );
      } else {
        // dispatch(
        //   AddCharacter({
        //     data: info,
        //     callback,
        //   })
        // );
      }
    } catch (error) {
      console.log(error, "<===err");
    }
  };
  const deleteHandler = (id) => {
    try {
      const callback = (err, res) => {
        if (err) {
          toast.error(err);
        } else {
          fetchData();
          toast.success(res.message);
        }
      };
      dispatch(
        deleteCharacterList({
          data: id,
          callback,
        }),
      );
    } catch (error) {
      console.log(error, "<===err");
    }
  };

  const handlePageChange = (page) => {
    setFilter((prev) => ({ ...prev, pageNo: page.selected + 1 }));
  };
  const handleViewUser = (id) => {
    navigate(`/beloved-character/${id}`);
  };

  const handleUserStatus = (item) => {
    try {
      const newStatus = item?.status === "active" ? "inactive" : "active";
      const callBack = (err, res) => {
        if (err) {
          toast.error(err);
        } else {
          fetchData();
          toast.success("Status Changed");
        }
      };
      dispatch(
        editCharacterStatus({
          data: { _id: item._id, status: newStatus },
          callBack,
        }),
      );
    } catch (error) {
      console.error(error, "<=== Error occurred");
    }
  };

  const handleUserBelovedStatus = (item) => {
    try {
      const newStatus = false;
      const callBack = (err, res) => {
        if (err) {
          toast.error(err);
        } else {
          fetchData();
          toast.success("Status Changed");
        }
      };
      dispatch(
        updateBelovedRealisticStatus({
          data: { _id: item, belovedRealistic: newStatus },
          callBack,
        }),
      );
    } catch (error) {
      console.error(error, "<=== Error occurred");
    }
  };

  const column = [
    {
      head: "Sr No",
      accessor: "",
      isComponent: true,
      component: (item, ind) => {
        const calculateRowIndex = (ind) =>
          (filter.pageNo - 1) * pageSize + (ind + 1);
        return (
          <span className="text-capitalize cursor-pointer">
            {calculateRowIndex(ind)}
          </span>
        );
      },
    },

    {
      head: "Avatar",
      accessor: "image",
      isComponent: true,
      component: (item, key) => {
        return (
          <>
            <div className="d-flex align-items-center gap-10">
              <div className="imgWrp flex-shrink-0">
                <img
                  src={item?.image}
                  alt="img"
                  style={{ height: 40, width: 40 }}
                  className="img-fluid object-fit-cover rounded-circle"
                />
              </div>
            </div>
          </>
        );
      },
    },
    {
      head: "Name",
      accessor: "name",
      isComponent: true,
      component: (item, ind) => (
        <span className="text">{capitalize(item?.name)}</span>
      ),
    },

    {
      head: "Modal Type ",
      accessor: "type",
      isComponent: true,
      component: (item, ind) => (
        <span className="text">{capitalize(item?.type)}</span>
      ),
    },
    {
      head: "Created At",
      accessor: "createdAt",
      isComponent: true,
      component: (item, ind) => (
        <span className="text">
          {moment(item?.createdAt).format("YYYY-MM-DD")}
        </span>
      ),
    },
    {
      head: "Remove Beloved",
      accessor: "",
      isComponent: true,
      component: (item) => (
        <div className="ActnBtn d-flex align-items-center  gap-10">
          <Button
            onClick={() => handleUserBelovedStatus(item._id)}
            className="p-0"
            variant="transparent"
            type="button"
          >
            <svg
              width="24"
              height="24"
              viewBox="0 0 16 16"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M8 1C6.14348 1 4.36301 1.7375 3.05025 3.05025C1.7375 4.36301 1 6.14348 1 8C1 9.85652 1.7375 11.637 3.05025 12.9497C4.36301 14.2625 6.14348 15 8 15C9.85652 15 11.637 14.2625 12.9497 12.9497C14.2625 11.637 15 9.85652 15 8C15 6.14348 14.2625 4.36301 12.9497 3.05025C11.637 1.7375 9.85652 1 8 1ZM4 7.5V8.5H12V7.5H4Z"
                fill="black"
              />
            </svg>
          </Button>
        </div>
      ),
    },
    {
      head: "Actions",
      accessor: "",
      isComponent: true,
      component: (item) => (
        <div className="ActnBtn d-flex align-items-center  gap-10">
          <Form.Check
            className="fs-5"
            style={{ cursor: "pointer" }}
            type="switch"
            id={`custom-switch-${item._id}`}
            checked={item.status === "active"}
            onClick={() => handleUserStatus(item)}
          />
          <Button
            onClick={() => handleViewUser(item._id)}
            className="p-0"
            variant="transparent"
            type="button"
          >
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M12 9C11.2044 9 10.4413 9.31607 9.87868 9.87868C9.31607 10.4413 9 11.2044 9 12C9 12.7956 9.31607 13.5587 9.87868 14.1213C10.4413 14.6839 11.2044 15 12 15C12.7956 15 13.5587 14.6839 14.1213 14.1213C14.6839 13.5587 15 12.7956 15 12C15 11.2044 14.6839 10.4413 14.1213 9.87868C13.5587 9.31607 12.7956 9 12 9ZM12 17C10.6739 17 9.40215 16.4732 8.46447 15.5355C7.52678 14.5979 7 13.3261 7 12C7 10.6739 7.52678 9.40215 8.46447 8.46447C9.40215 7.52678 10.6739 7 12 7C13.3261 7 14.5979 7.52678 15.5355 8.46447C16.4732 9.40215 17 10.6739 17 12C17 13.3261 16.4732 14.5979 15.5355 15.5355C14.5979 16.4732 13.3261 17 12 17ZM12 4.5C7 4.5 2.73 7.61 1 12C2.73 16.39 7 19.5 12 19.5C17 19.5 21.27 16.39 23 12C21.27 7.61 17 4.5 12 4.5Z"
                fill="#6F6F6F"
              />
            </svg>
          </Button>
        </div>
      ),
    },
  ];

  return (
    <>
      {loading && (
        <div className="main-loader">
          <FadeLoader size={1000} />
        </div>
      )}

      <section className="ManageTeacher position-relative">
        <Row className="mb-3 px-4 d-flex  align-items-center  cardCstm py-2 px-4">
          <Col lg="12" className="my-2 px-0">
            <div className="px-3 d-flex align-items-center justify-content-between gap-10">
              <h5 className="mb-0 py-3 fw-sbold text-capitalize px-3">
                Beloved Character
              </h5>
            </div>
          </Col>
          {/* <Col md={4} className="px-4">
            <Form.Control
              type="text"
              name="search"
              placeholder="Search"
              value={search}
              onChange={(e) =>
                setFilter((prev) => ({ ...prev, search: e.target.value }))
              }
            />
          </Col> */}
          <Col md={3} className="">
            <label htmlFor="" className="form-label block m-0 fw-sbold">
              Style
            </label>
            <Form.Select
              className="py-2"
              value={style}
              onChange={(e) => {
                setStyle(e.target.value);
                setFilter((prev) => ({
                  ...prev,
                  style: e.target.value,
                }));
              }}
            >
              <option value="Realistic">Realistic</option>
              <option value="Anime">Anime</option>
              {/* <option value="Fantasy">Fantasy</option>
              <option value="Roleplay">Roleplay</option> */}
            </Form.Select>
            {/* <div className="d-flex gap-3">
              <Button
                // onClick={handleFilter}
                variant="primary"
                className="py-2 px-3"
              >
                Filter
              </Button>
              <Button
                // onClick={clearFilter}
                variant="secondary"
                className="py-2 px-3"
              >
                Clear
              </Button>
            </div> */}
          </Col>
        </Row>
        {!loading && (
          <Row>
            <Col lg="12" className="">
              <div className="cardCstm p-3 rounded bg-white">
                {!loading && CHARACTERLIST?.length > 0 ? (
                  <>
                    <TableLayout
                      data={CHARACTERLIST}
                      column={column}
                      totalCount={totalCount}
                      limit={pageSize}
                      handlePageChange={handlePageChange}
                      pageNo={filter.pageNo}
                    />
                  </>
                ) : (
                  <div className="d-flex justify-content-center">
                    <p>No Data Found</p>
                  </div>
                )}
              </div>
            </Col>
          </Row>
        )}
      </section>
    </>
  );
};
export default PublicCharacter;
